<template>
  <div>
    <base-header class="pb-6 pb-8 pt-5 pt-md-8 bg-gradient-default" />
    <b-container fluid class="mt--7">
      <b-row class="mb-2">
        <b-col>
          <b-card>
            <h4>Crear pregunta - Respuesta</h4>
            <form @submit.prevent="save">
              <b-form-group label="Pregunta">
                <b-form-input
                  required
                  v-model="model.title"
                  placeholder="Pregunta"
                />
              </b-form-group>
              <b-form-group label="Respuesta">
                <b-form-textarea
                  required
                  v-model="model.description"
                  placeholder="Respuesta"
                />
              </b-form-group>
              <b-form-group>
                <b-button type="submit" variant="primary">
                  Guardar
                </b-button>
              </b-form-group>
            </form>
          </b-card>
        </b-col>
        <b-col>
          <b-card>
            <h4>Subir archivo</h4>
            <form @submit.prevent="saveFile">
              <b-form-group label="Titulo">
                <b-form-input
                  required
                  v-model="modelFile.title"
                  placeholder="Titulo para el archivo"
                />
              </b-form-group>
              <b-form-group label="File">
                <b-form-file
                  required
                  v-model="modelFile.file"
                />
              </b-form-group>
              <b-form-group>
                <b-button type="submit" variant="primary">
                  Guardar
                </b-button>
              </b-form-group>
            </form>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="8">
          <faq-list @edit="onToEdit" ref="faq_list"/>
        </b-col>
        <b-col>
          <faq-file-list ref="faq_files" />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import FaqList from "@/views/Dashboard/faqs/FaqList";
import {post} from "@/util/axiosRequest";
import FaqFileList from "@/views/Dashboard/faqs/FaqFileList";
export default {
  name: "Faqs",
  components: {FaqFileList, FaqList},
  data() {
    return {
      edit: false,
      model: {
        title: '',
        description: '',
      },
      modelFile: {
        file: null,
        title: '',
      },
    };
  },
  methods:{
    onToEdit(item){
      this.edit = item
      this.model.title = item.title
      this.model.description = item.description
    },
    save(){
      const url = this.edit ? `faqs/update/${this.edit._id}` : 'faqs';
      post(url, this.model, true)
      .then(() => {
        this.edit = false
        this.model = {
          title: '',
          description: '',
        }
        this.showMessage('Pregunta guardada');
        this.$refs.faq_list.getList()
      })
      .catch(() => {
        this.showMessage('Error al guardar la pregunta', 'error')
      });
    },
    saveFile(){
      const formData = new FormData();
      formData.append('title', this.modelFile.title);
      formData.append('file', this.modelFile.file);
      post('faqs/file', formData, true)
      .then(() => {
        this.showMessage('Archivo guardado');
        this.$refs.faq_files.getList()
      })
      .catch(() => {
        this.showMessage('Error al guardar el archivo', 'error');
      });
    },
    showMessage(message, type = 'success') {
      this.$swal({
        html: message,
        icon: (type === "success") ? 'success' : 'error',
        showCloseButton: true,
        show: false,
        confirmButtonColor: '#191c4d',
        cancelButtonColor: '#191c4d',
      });
    },
  }
}
</script>

<style scoped>

</style>
